module.exports = __webpack_public_path__ + "static/logo-f346be240b514e47bbc1233c01e744c9.png";